// extracted by mini-css-extract-plugin
export default {"containerPage":"Loader_containerPage__mZbxn"};